define('dialog/css',["utils/constants", "utils/user_agent"], function(CONST, UserAgent){
  var styles = ".id-dialog-box {position:absolute; display:none; z-index:9000; overflow: hidden;}\n" +
  ".id-dialog-content {overflow: hidden;}\n" +
  ".id-dialog-inner {overflow: hidden; line-height: 0; background: url(" +CONST.assetsRootUrl()+ "/assets/tinybox/preload.gif) no-repeat 50% 50%; }\n" +
  ".id-dialog-mask {position:absolute; display:none; top:0px; left:0px; height:100%; width:100%; background:#000; z-index:800; opacity: 0.8; -moz-opacity: 0.8; filter:alpha(opacity=80);	-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=80)\";-khtml-opacity:0.5; zoom: 1;}\n" +
  ".id-dialog-close {position:absolute; top:0px; right:0px; width:30px; height:30px; cursor:pointer; background:url("+CONST.assetsRootUrl()+"/assets/tinybox/close.png) no-repeat}\n.id-dialog-close:hover {background-position:0 -30px}\n" +
  ".id-dialog-lock {overflow: hidden;}\n";

  if (!UserAgent.ie()) {
    var style = document.createElement('style');
    style.type = 'text/css';
    style.textContent = styles;
    document.getElementsByTagName('head')[0].appendChild(style);
  } else {
    try {
      document.createStyleSheet().cssText = styles;
    } catch (exc) {
      if (document.styleSheets[0]) {
        document.styleSheets[0].cssText += styles;
      }
    }
  }
  return styles;
});

